<template>
  <div class="m_audit_platform">
    <MobilePageBanner
      :background-image="
        require('@/assets/images/mobile/audit_platform/banner@2x.png')
      "
      :slogans="['智能人机协同作业平台，', '快速获得内容安审能力']"
      button-href="https://www.yunaq.com/activity/activityform?name=业务安全"
    ></MobilePageBanner>
    <div class="m_des">
      提供标准化内容审核平台，可用于：个人&企业认证、文本、图像、视频、图文、音频内容安全审核支持自定义有害标签及过滤规则，可本地化部署。
    </div>
    <div class="m_panel">
      <div class="m_title">行业痛点</div>
      <div class="mapp_icon">
        <img src="@/assets/images/zhineng/tongdian1@2x.png" alt="" />
      </div>
      <div class="mapp_title">数据无法开放</div>
      <div class="m_des_item Mb24">
        平台运营者往往有很强的业务能力，但缺乏业务流程运营视角，故在运营质量和效能提升上，需要更多摸索和尝试。
      </div>
      <div class="mapp_icon">
        <img src="@/assets/images/zhineng/tongdian2@2x.png" alt="" />
      </div>
      <div class="mapp_title">运营者缺少内容安全风控经验</div>
      <div class="m_des_item Mb24">
        平台运营者往往有很强的业务能力，但缺乏业务流程运营视角，故在运营质量和效能提升上，需要更多摸索和尝试。
      </div>
      <div class="mapp_icon">
        <img src="@/assets/images/zhineng/tongdian3@2x.png" alt="" />
      </div>
      <div class="mapp_title">开发维护成本较高</div>
      <div class="m_des_item Mb24">
        流程的改进和平台的升级，都会带来大量的技术投入和研发成本。
      </div>
    </div>
    <div class="m_panel" style="background: #f7f9fc">
      <div class="m_title">服务内容</div>
      <div class="mapp_icon">
        <img src="@/assets/images/zhineng/service1@2x.png" alt="" />
      </div>
      <div class="mapp_title">企业&个人认证审核平台</div>
      <div class="maps_des Mb24">
        支持企业&个人认证审核作业，提供字段定制、流程定制、角色定制、运营看板等功能。
      </div>
      <div class="mapp_icon">
        <img src="@/assets/images/zhineng/service2@2x.png" alt="" />
      </div>
      <div class="mapp_title">内容审核平台</div>
      <div class="maps_des Mb24">
        支持视频、音频、图像、文字、文章内容安审作业，提供标签定制、关键词定制、流程定制、角色定制、运营看板等功能。
      </div>
    </div>
    <div class="m_panel">
      <div class="m_title">服务流程</div>
      <img
        src="@/assets/images/mobile/audit_platform/service_process@2x.png"
        alt=""
      />
    </div>
    <div class="m_panel" style="background: #f7f9fc">
      <div class="m_title Mb12">产品功能</div>
      <div class="masf_container">
        <div class="masf_item">
          <img src="@/assets/images/zhineng/product1@2x.png" alt="" />
          <div class="masf_title">人审规模600+</div>
          <div class="masf_des">
            根据不同的业务场景和平台差异化，定义字段和标签，且可同时满足多套标签。
          </div>
        </div>
        <div class="masf_item">
          <img src="@/assets/images/zhineng/product2@2x.png" alt="" />
          <div class="masf_title">审核流程配置</div>
          <div class="masf_des">
            根据不用的业务场景和准确率要求，配置对应审核模式和流程，确保审核质量和时效。
          </div>
        </div>
        <div class="masf_item">
          <img src="@/assets/images/zhineng/product3@2x.png" alt="" />
          <div class="masf_title">权限角色配置</div>
          <div class="masf_des">
            根据团队特性，灵活定义不同的角色和权限，如：审核员、质检员、主管、管理员等。
          </div>
        </div>
        <div class="masf_item">
          <img src="@/assets/images/zhineng/product4@2x.png" alt="" />
          <div class="masf_title">运营看板</div>
          <div class="masf_des">
            支持个人、项目、业务等多维度的数据展示，量化运营数据，为团队精细化原因提供参考。
          </div>
        </div>
        <div class="masf_item">
          <img src="@/assets/images/zhineng/product5@2x.png" alt="" />
          <div class="masf_title">多端协同</div>
          <div class="masf_des">
            可进行移动端与 PC 端协同作业，实现全时段及多场景覆盖。
          </div>
        </div>
        <div class="masf_item">
          <img src="@/assets/images/zhineng/product6@2x.png" alt="" />
          <div class="masf_title">在线培训</div>
          <div class="masf_des">
            关联业务标准培训及能力考核，帮助团队快速掌握业务能力。
          </div>
        </div>
      </div>
      <div class="Tac Mt8">
        <a
          class="m_btn"
          href="https://www.yunaq.com/activity/activityform?name=业务安全"
        >
          立即咨询
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import MobilePageBanner from '@/components/mobile/MobilePageBanner'

export default {
  name: 'MobileAuditPlatform',
  components: {
    MobilePageBanner,
  },
}
</script>

<style lang="scss">
.m_audit_platform {
  text-align: start;
  .mapp_icon {
    text-align: center;
    > img {
      width: 60px;
    }
  }
  .mapp_title {
    margin: 12px 0;
    line-height: 24px;
    font-size: 14px;
    text-align: center;
  }
  .maps_des {
    padding: 0 16px;
    font-size: 12px;
    line-height: 16px;
    color: #686c78;
  }
  .masf_container {
    display: flex;
    width: calc(100% + 12px);
    flex-flow: wrap;
  }
  .masf_item {
    display: flex;
    padding: 12px;
    flex-direction: column;
    box-sizing: border-box;
    min-height: 188px;
    width: calc(50% - 12px);
    margin-right: 12px;
    margin-top: 12px;
    align-items: center;
    justify-content: center;
    background: #fff;
    border: 1px solid #e6eaef;
    > img {
      width: 40px;
      height: 40px;
    }
    .masf_title {
      font-size: 12px;
      line-height: 24px;
      color: #1e1f23;
      margin-top: 8px;
      margin-bottom: 4px;
    }
    .masf_des {
      font-size: 12px;
      line-height: 20px;
      color: #686c78;
    }
  }
}
</style>
